import { defineComponent } from "vue";
import { usePortalStore } from "@/framework/portal";

export default defineComponent ({
    name: 'CircularProgress',
    setup() {
        const portal = usePortalStore()
        return {
            portal
        };
    }
})